import {
  STAFF_CONTACT_TYPE_LIST, STAFF_CONTACT_TYPE_LIST_SUCCESS, STAFF_CONTACT_TYPE_LIST_FAILURE,
  STAFF_CONTACT_TYPE_CREATE, STAFF_CONTACT_TYPE_CREATE_SUCCESS, STAFF_CONTACT_TYPE_CREATE_FAILURE,
  STAFF_CONTACT_TYPE_UPDATE, STAFF_CONTACT_TYPE_UPDATE_SUCCESS, STAFF_CONTACT_TYPE_UPDATE_FAILURE,
  STAFF_CONTACT_TYPE_DELETE, STAFF_CONTACT_TYPE_DELETE_SUCCESS, STAFF_CONTACT_TYPE_DELETE_FAILURE,
  STAFF_CONTACT_LIST, STAFF_CONTACT_LIST_SUCCESS, STAFF_CONTACT_LIST_FAILURE,
  STAFF_CONTACT_CREATE, STAFF_CONTACT_CREATE_SUCCESS, STAFF_CONTACT_CREATE_FAILURE,
  STAFF_CONTACT_UPDATE, STAFF_CONTACT_UPDATE_SUCCESS, STAFF_CONTACT_UPDATE_FAILURE,
  STAFF_CONTACT_DELETE, STAFF_CONTACT_DELETE_SUCCESS, STAFF_CONTACT_DELETE_FAILURE,
} from "./actionType";

export const staffContactTypeList = (data) => ({ type: STAFF_CONTACT_TYPE_LIST, payload: data });
export const staffContactTypeListSuccess = (data) => ({ type: STAFF_CONTACT_TYPE_LIST_SUCCESS, payload: data });
export const staffContactTypeListFailure = (error) => ({ type: STAFF_CONTACT_TYPE_LIST_FAILURE, payload: error });

export const staffContactTypeCreate = (data) => ({ type: STAFF_CONTACT_TYPE_CREATE, payload: data });
export const staffContactTypeCreateSuccess = (data) => ({ type: STAFF_CONTACT_TYPE_CREATE_SUCCESS, payload: data });
export const staffContactTypeCreateFailure = (error) => ({ type: STAFF_CONTACT_TYPE_CREATE_FAILURE, payload: error });

export const staffContactTypeUpdate = (data) => ({ type: STAFF_CONTACT_TYPE_UPDATE, payload: data });
export const staffContactTypeUpdateSuccess = (data) => ({ type: STAFF_CONTACT_TYPE_UPDATE_SUCCESS, payload: data });
export const staffContactTypeUpdateFailure = (error) => ({ type: STAFF_CONTACT_TYPE_UPDATE_FAILURE, payload: error });

export const staffContactTypeDelete = (data) => ({ type: STAFF_CONTACT_TYPE_DELETE, payload: data });
export const staffContactTypeDeleteSuccess = (data) => ({ type: STAFF_CONTACT_TYPE_DELETE_SUCCESS, payload: data });
export const staffContactTypeDeleteFailure = (error) => ({ type: STAFF_CONTACT_TYPE_DELETE_FAILURE, payload: error });

export const staffContactList = (data) => ({ type: STAFF_CONTACT_LIST, payload: data });
export const staffContactListSuccess = (data) => ({ type: STAFF_CONTACT_LIST_SUCCESS, payload: data });
export const staffContactListFailure = (error) => ({ type: STAFF_CONTACT_LIST_FAILURE, payload: error });

export const staffContactCreate = (data) => ({ type: STAFF_CONTACT_CREATE, payload: data });
export const staffContactCreateSuccess = (data) => ({ type: STAFF_CONTACT_CREATE_SUCCESS, payload: data });
export const staffContactCreateFailure = (error) => ({ type: STAFF_CONTACT_CREATE_FAILURE, payload: error });

export const staffContactUpdate = (data) => ({ type: STAFF_CONTACT_UPDATE, payload: data });
export const staffContactUpdateSuccess = (data) => ({ type: STAFF_CONTACT_UPDATE_SUCCESS, payload: data });
export const staffContactUpdateFailure = (error) => ({ type: STAFF_CONTACT_UPDATE_FAILURE, payload: error });

export const staffContactDelete = (data) => ({ type: STAFF_CONTACT_DELETE, payload: data });
export const staffContactDeleteSuccess = (data) => ({ type: STAFF_CONTACT_DELETE_SUCCESS, payload: data });
export const staffContactDeleteFailure = (error) => ({ type: STAFF_CONTACT_DELETE_FAILURE, payload: error });
